// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"389":"YTMediaAPI","727":"YTDataAPI"}[chunkId] + ".js";
};